import { useCallback } from 'react';

import type { Action, Content } from '../global-types/Content';
import { useHandleCallback } from './useHandleCallback';
import { useHandleContentUrl } from './useHandleContentUrl';

type DispatchFn = (action: Action, nextContent?: Content | null) => void;

export function useHandleActionClick(dispatchActionEvent: DispatchFn) {
  const { mutate: sendCallback } = useHandleCallback();
  const { mutateAsync: fetchNextContent } = useHandleContentUrl();

  const handleActionClick = useCallback(
    async (action: Action) => {
      if (action.callback) {
        sendCallback({
          url: `${action.callback.baseUrl ?? ''}${action.callback.callbackPath}`,
          payload: action.callback.payload,
        });
      }

      let nextContent: Content | null = null;
      const nextContentUrl = action.loadViews?.find((lv) => !!lv.contentUrl)?.contentUrl;
      if (nextContentUrl) {
        nextContent = await fetchNextContent({ url: nextContentUrl });
      }

      dispatchActionEvent(action, nextContent);
    },
    [dispatchActionEvent, fetchNextContent, sendCallback],
  );

  return { handleActionClick };
}
